export enum MercureTopic {
  DeviceEvent = 'device-event',
  DeviceHeartbeat = 'device-heartbeat',
  EntityChanged = 'entity-changed'
}
